// extracted by mini-css-extract-plugin
export default {"scenario-warning":"ScenarioValidityWarning_scenario-warning__LrnZe"};